import GrayHeaderCard from "../../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import {useEffect} from "react";
import * as actions from "../../../../../../../store";
import {useDispatch, useSelector} from "react-redux";
import DCDeviceTable from "./DCDeviceTable";
import Typography from "@material-ui/core/Typography";
import {useParams} from "react-router-dom";

const DigitalContractDevice = () => {
    const dispatch = useDispatch();

    const {digitalContractId} = useParams()

    const cardTitle = <Typography variant="subtitle1">Device</Typography>
    const cacheLoading = useSelector((state) => state.authReducer.cacheDigitalContractLoading)

    useEffect(() => {
        if (!cacheLoading) {
            dispatch(actions.getDeviceTableData(digitalContractId))
        }
    }, [dispatch, digitalContractId, cacheLoading])


    return (
        <GrayHeaderCard title={cardTitle}>
            <DCDeviceTable/>
        </GrayHeaderCard>
    )
}

export default DigitalContractDevice;
